import { useState } from 'react';
import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { ReferenceInput } from 'react-admin';
import type { AntennaId } from '@wwf/sdk';
import { MissionContactAutocompleteInput } from '@app/mission/edit/MissionContactAutocompleteInput';

interface MissionContactReferenceInputProps {
    source?: string;
    antennaId?: AntennaId;
    label?: string;
    helperText?: string | false;
    antennaFilter?: (antennaId: AntennaId) => Record<string, unknown>;
}

export const MissionContactReferenceInput = ({
    source = 'contactId',
    antennaId,
    label,
    helperText,
    antennaFilter = antennaId => ({ antennaId }),
}: MissionContactReferenceInputProps) => {
    const [onlyCurrentAntenna, setOnlyCurrentAntenna] = useState(true);
    const requiresAntenna = onlyCurrentAntenna && !antennaId;

    return (
        <Stack gap={0.5}>
            <ReferenceInput
                source={source}
                reference="member"
                enableGetChoices={() => !onlyCurrentAntenna || !!antennaId}
                filter={{
                    ...(onlyCurrentAntenna &&
                        antennaId &&
                        antennaFilter(antennaId)),
                }}
                sort={{ field: 'firstName', order: 'ASC' }}
            >
                <MissionContactAutocompleteInput
                    disabled={requiresAntenna}
                    label={label}
                    helperText={
                        requiresAntenna ? 'No antenna selected' : helperText
                    }
                />
            </ReferenceInput>

            <FormControlLabel
                control={
                    <Checkbox
                        size="small"
                        checked={onlyCurrentAntenna}
                        onChange={(_, c) => setOnlyCurrentAntenna(c)}
                    />
                }
                label={
                    <Typography
                        variant="caption"
                        component="span"
                        color="text.secondary"
                        lineHeight={1.25}
                    >
                        Only members from the current mission antenna
                    </Typography>
                }
                sx={{
                    m: 0,
                    alignItems: 'center',
                    gap: 0.5,
                    ml: 0.25,
                }}
            />
        </Stack>
    );
};
